export const Users = [ 
    { 
        id:1,
        firstName:"ทดสอบ1",
        lastName:"ระบบ1",
        cardNumber:"1111111111111",
        houseCodeNumber:"123",
        registrationOffice:"123",
        buildingName:"test",
        address:"test",
        floor:"2",
        villageNumber:"10",
        lane:"-",
        road:"กระนวน",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        postalCode:"40000",
        phoneNumber:"0974532678",
        email:"test@gmail.com",
        personType:"1"
    },
    { 
        id:2,
        firstName:"ทดสอบ2",
        lastName:"ระบบ2",
        cardNumber:"2222222222222",
        houseCodeNumber:"123",
        registrationOffice:"123",
        buildingName:"test",
        address:"test",
        floor:"2",
        villageNumber:"10",
        lane:"-",
        road:"กระนวน",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        postalCode:"40000",
        phoneNumber:"0974532678",
        email:"test@gmail.com",
        personType:"2"
    },
    { 
        id:3,
        firstName:"ทดสอบ3",
        lastName:"ระบบ3",
        cardNumber:"3333333333333",
        houseCodeNumber:"123",
        registrationOffice:"123",
        buildingName:"test",
        address:"test",
        floor:"2",
        villageNumber:"10",
        lane:"-",
        road:"กระนวน",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        postalCode:"40000",
        phoneNumber:"0974532678",
        email:"test@gmail.com",
        personType:"3"
    },
    { 
        id:4,
        firstName:"ทดสอบ4",
        lastName:"ระบบ4",
        cardNumber:"4444444444444",
        houseCodeNumber:"123",
        registrationOffice:"123",
        buildingName:"test",
        address:"test",
        floor:"2",
        villageNumber:"10",
        lane:"-",
        road:"กระนวน",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        postalCode:"40000",
        phoneNumber:"0974532678",
        email:"test@gmail.com",
        personType:"4"
    },
    { 
        id:5,
        firstName:"ทดสอบ5",
        lastName:"ระบบ5",
        cardNumber:"5555555555555",
        houseCodeNumber:"123",
        registrationOffice:"123",
        buildingName:"test",
        address:"test",
        floor:"2",
        villageNumber:"10",
        lane:"-",
        road:"กระนวน",
        province:"มหาสารคาม",
        district:"เชียงยืน",
        subDistrict:"เชียงยืน",
        postalCode:"40000",
        phoneNumber:"0974532678",
        email:"test@gmail.com",
        personType:"5"
    },
]